import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import Enums from '@xbs/xbs-enums';

import { NotificationService } from '../../../../shared/services/notifications.service';
import { ModalService } from '../../../../shared/modules/modal/modal.service';

import { ClosableModalWithErrorResponseModel } from 'src/app/shared/components/base/closable-modal-with-error-response-model';
import { PlisDisplayFormatService } from '../../../../shared/services/pli-display-format-service';
import { PliConstants } from '../../../../shared/constants/pli';
import { PliDisplayFormat } from '../../../../shared/models/pli-format';
import { EditPliSettingsModalPayload } from '../../../../shared/models';

@Component({
  selector: 'edit-pli-settings-modal',
  templateUrl: './edit-pli-settings-modal.component.html',
  styleUrls: ['./edit-pli-settings-modal.component.css', '../tune-comparable-search.component.css']
})

export class EditPLISettingsModalComponent extends ClosableModalWithErrorResponseModel<any> implements OnInit {

  plis: PliDisplayFormat[] = [];
  pliTypes = Enums.PliTypes;
  data: EditPliSettingsModalPayload;
  pliTypeId: number;
  decimalPlacesRounding = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  percentageRounding = [1, 2, 3, 4, 5, 6, 7];
  
  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _pliDisplayFormatService: PlisDisplayFormatService,
    private _activatedRoute: ActivatedRoute,
  ) {
    super(notificationService, modalService);
  }
  ngOnInit(): void {
    this._pliDisplayFormatService.getPliDisplayFormat(this.data.compSearchId, this.data.jurisdictionId).subscribe((response: {data}) => {
      this.plis = [];
      const pliKeys = Object.keys(this.data.pliData);
      pliKeys.forEach((pli) => {
        const pliFormat = response.data.find(pliType => pliType.pliTypeId === this.data.pliData[pli].pliTypeId);
        const pliFormatType = {
          name: this.data.pliData[pli].pli,
          pliTypeId: this.data.pliData[pli].pliTypeId,
          pliAverageTypeId: this.data.pliData[pli].pliAvgTypeId,
          displayFormat: pliFormat && pliFormat.hasOwnProperty('displayFormat') ? pliFormat.displayFormat : Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.displayFormat,
          roundingValue: pliFormat && pliFormat.hasOwnProperty('roundingValue') ? pliFormat.roundingValue : Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.roundingValue,
          roundingRange: pliFormat && pliFormat.displayFormat === 0 || Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.displayFormat === 0 ? this.percentageRounding : this.decimalPlacesRounding
        };
        this.plis.push(pliFormatType);
      });
    }, () => {
      this.getDefaultPliDisplayValues();
    });

  }
  
  save(): void {
    const requests = [];
    this.plis.forEach((pli) => {
      const pliDisplayUpdate = { displayFormat: pli.displayFormat, roundingValue: pli.roundingValue };
      requests.push(this._pliDisplayFormatService.savePliDisplayFormat(pli.pliTypeId, pli.pliAverageTypeId, this.data.compSearchId, this.data.jurisdictionId, pliDisplayUpdate));
    });
    forkJoin(requests).subscribe(() => {
      this._pliDisplayFormatService.init();
      this.success();
      this.modalService.closeModal();
    });
  }
  
  close(): void {
    this.modalService.closeModal();
  }
  
  decimalSelected(pli): void {
    pli.displayFormat = 1;
    pli.roundingValue = PliConstants.PLI_ROUNDING.DECIMAL_ROUND_TO;
    pli.roundingRange = this.decimalPlacesRounding;
  }
  
  percentSelected(pli): void {
    pli.displayFormat = 0;
    pli.roundingValue = PliConstants.PLI_ROUNDING.PERCENTAGE_ROUND_TO;
    pli.roundingRange = this.percentageRounding;
  }
  
  updateRounding(pli, num): void {
    pli.roundingValue = num;
  }
  
  private getDefaultPliDisplayValues(): void {
    const pliKeys = Object.keys(this.data.pliData);
    pliKeys.forEach((pli) => {
      const pliFormatType = {
        name: this.data.pliData[pli].pli,
        pliTypeId: this.data.pliData[pli].pliTypeId,
        pliAverageTypeId: this.data.pliData[pli].pliAvgTypeId,
        displayFormat: Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.displayFormat,
        roundingValue: Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.roundingValue,
        roundingRange: Enums.PliDisplayFormats.ById[this.data.pliData[pli].pliTypeId].Value.displayFormat === 0 ? this.percentageRounding : this.decimalPlacesRounding
      };
      this.plis.push(pliFormatType);
    });
  }

}
